import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { popModalScreen } from "domains/modal/actions";
import { removeNotificationFailure, removeNotificationSuccess } from "domains/notifications/actions";
import type { RemoveNotificationDefaultAction } from "domains/notifications/actionTypes";

export function* removeNotificationSaga(action: RemoveNotificationDefaultAction) {
  try {
    yield apiFetch(`notification/${action.meta.id}`, { method: "DELETE" });
    yield put(removeNotificationSuccess(action.meta.id));
    yield put(popModalScreen());
  } catch {
    yield put(removeNotificationFailure({ id: action.meta.id, logoutOnAuthError: true }));
  }
}
